import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Camera, Loader2 } from "lucide-react";

export function PhotoReminderButton({ branchId }) {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  const params = { branch_id: branchId === "all" ? undefined : branchId };
  const load = () => api.get("/student-photo-reminder", { params }).then((r) => setInfo(r.data)).catch(() => setInfo(null));
  useEffect(() => { load(); }, [branchId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!info || !info.students_without_photo) return null;
  async function send() {
    if (!window.confirm(`Send a notice to ${info.parents_reachable} parent(s) asking them to add their child's photo? ${info.students_without_photo} students have no photo.`)) return;
    setBusy(true);
    try {
      const r = await api.post("/student-photo-reminder", null, { params });
      toast.success(`Reminder sent to ${r.data.parents_notified} parent(s)`);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  }
  return (
    <Button data-testid="photo-reminder-btn" variant="outline" onClick={send} disabled={busy || !info.parents_reachable}
      title={info.parents_reachable ? "" : "None of these students has a parent account linked yet"}
      className="h-11 border-violet-200 text-violet-700">
      {busy ? <Loader2 size={16} className="animate-spin mr-2" /> : <Camera size={16} className="mr-2" />}
      Ask parents for photos ({info.students_without_photo})
    </Button>
  );
}
